<template>
  <div>
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-navbar></layout-navbar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">

        <!-- Page Content -->
        <div class="content container-fluid">

          <div class="crms-title row bg-white">
            <div class="col  p-0">
              <h3 class="page-title m-0">
                        <span class="page-title-icon bg-gradient-primary text-white mr-2">
                          <i class="feather-grid"></i>
                        </span> AV Prüfung </h3>
            </div>
            <div class="col p-0 text-right">
              <ul class="breadcrumb bg-white float-right m-0 pl-0 pr-0">
                <li class="breadcrumb-item"><router-link to="/index">DSMS</router-link></li>
                <li class="breadcrumb-item active">AV Prüfung</li>
              </ul>
            </div>
          </div>
          <!-- Page Header -->
          <div class="page-header pt-3 mb-0 ">
            <div class="row" v-show="!taskSetup">
              <div class="col-xl-6 d-flex">
                <div class="card flex-fill">
                  <div class="card-header">
                    <h4 class="card-title mb-0">Vertrag Details</h4>
                  </div>
                  <div class="card-body">
                      <div class="form-group row">
                        <label class="col-lg-4 col-form-label">Prüfbogen<span class="text-danger">*</span></label>
                        <div class="col-lg-8">
                          <select class="form-control" v-model="surveyID" id="surveyID" @change="surveyIDSelect">
                            <option :selected="true" value="1">AVCheck Fragebogen</option>
                          </select>
                          <span class="error-message text-danger" v-show="v$.surveyID.$errors.length>0">{{ $t('required_field') }}</span>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label class="col-lg-4 col-form-label">Partner Name<span class="text-danger">*</span></label>
                        <div class="col-lg-8">
                          <select class="form-control partner-select" v-model="partner" v-select2>
                          </select>
                          <span class="error-message text-danger" v-show="v$.partner.$errors.length>0">{{ $t('required_field') }}</span>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label class="col-lg-4 col-form-label">Partner Adresse</label>
                        <div class="col-lg-8">
                          <textarea type="text" class="form-control" v-model="partnerAddress"/>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label class="col-lg-4 col-form-label">Auftragsgeber<span class="text-danger">*</span></label>
                        <div class="col-lg-8">
                          <select class="form-control" v-model="auftragsgeber">
                            <option selected :value="partnerName === '' ? 'Partner' : partnerName">{{partnerName === '' ? 'Partner' : partnerName}}</option>
                            <option :value="accountName">{{accountName}}</option>
                          </select>
                          <span class="error-message text-danger" v-show="v$.auftragsgeber.$errors.length>0">{{ $t('required_field') }}</span>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label class="col-lg-4 col-form-label">Vertragsname<span class="text-danger">*</span></label>
                        <div class="col-lg-8">
                          <input type="text" class="form-control" v-model="contractName"/>
                          <span class="error-message text-danger" v-show="v$.contractName.$errors.length>0">{{ $t('required_field') }}</span>
                        </div>
                      </div>
                      <div class="file-list form-group row">
                        <div
                          v-for="(file, index) in contractFiles"
                          :key="file.id"
                          class="file-item"
                        >
                          <span class="filename">{{ file.name }}</span>
                          <span class="remove" @click="removeFile(index)">×</span>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label class="col-lg-8 col-form-label">AV Vertrag hochladen (mehrere Dateien können ausgewählt werden)<span class="text-danger">*</span></label>
                        <div class="col-lg-4">
                          <input type="file" class="form-control" ref="fileInput" @change="selectFile" multiple="multiple" style="display: none" accept=".pdf, .docx" />
                          <button class="btn btn-primary btn-sm" @click="openFileDialog">Datei hinzufügen</button>
                        </div>
                        <span class="error-message text-danger" v-show="v$.contractFiles.$errors.length>0">{{ $t('required_field') }}</span>
                      </div>
                      <div class="form-group row">
                        <label class="col-lg-4 col-form-label">PDF-Passwort (mehrere Passwörter mit "," trennen)<span class="text-danger">*</span></label>
                        <div class="col-lg-8">
                          <input type="text" class="form-control" v-model="pdfPasswords"/>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label class="col-lg-4 col-form-label">Bemerkungen</label>
                        <div class="col-lg-8">
                          <textarea class="form-control" v-model="remarks" placeholder="Beschreibung für GAP/Bericht" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label class="col-lg-4 col-form-label">Aufnahme in die GAP</label>
                        <div class="col-lg-8">
                          <div class="checkbox">
                            <label>
                              <input type="checkbox" name="gap_input" checked v-model="gapInput"> Aufnahme in die GAP
                            </label>
                          </div>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label class="col-lg-4 col-form-label">gekürzte Version</label>
                        <div class="col-lg-8">
                          <div class="checkbox">
                            <label>
                              <input type="checkbox" name="status_sign" v-model="statusSign"> gekürzte Version
                            </label>
                          </div>
                        </div>
                      </div>
                      <div class="text-right">
                        <!--<router-link :to="{name: 'avv-content', params: {surveyJson: surveyJson, partnerName: partnerName, partnerAddress: partnerAddress, contractName: contractName, gapInput: gapInput, filename: filename, auftragsgeber: auftragsgeber, remarks: remarks}}" @click.native="uploadFile">-->
                          <button class="btn btn-outline-secondary" @click="exportSurveyToExcel">Prüfbogen exportieren</button>
                          <button class="btn btn-primary" @click="uploadFile">Weiter</button>
                        <!--</router-link>-->
                      </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-show="taskSetup">
              <div class="col-xl-6 d-flex">
                <div class="card flex-fill">
                  <div class="card-body">
                    <p> Der Vertrag wird von KI geprüft. Wenn der Status auf "Vorgeprüft" zeigt, bitte die Ergebnisse kontrollieren! </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { service, baseURL } from '@/utils/request'
import {mapState} from 'vuex'
import {required} from "@vuelidate/validators";
import {useVuelidate} from "@vuelidate/core";
import {surveyToExcel, makeAVCoverSheet} from '@/utils/exportToExcel'

export default {
  name: 'CustomerInfo',
  data: function() {
    return {
      contractFiles: [],
      filename: '',
      contractName: '',
      customer_name: '',
      selected_accounts: [],
      accounts: [],
      // file_customer_name: {'customerName': customer_name},
      customerAddress: '',
      partner: '',
      partnerName: '',
      partnerAddress: '',
      remarks: '',
      auftragsgeber: '',
      pdfPasswords: '',
      loading: false,
      surveyJson: {},
      base_url: baseURL,
      surveyID: 1,
      gapInput: true,
      statusSign: false,
      suppliers: [],
      selectSuppliers: [],
      suppliersID: [],
      partnerID: null,
      currentPartner: null,
      surveyResult: null,
      taskSetup: false,
      fileId: 0,
    }
  },
  computed: {...mapState({accountid: state => state.account.accountid, accountName: state => state.account.name, userID: state => state.user.id}), },
  validations() {
    return {
      surveyID: {required, $lazy: true},
      partner: {required, $lazy: true},
      contractName: {required, $lazy: true},
      auftragsgeber: {required, $lazy: true},
      contractFiles: {required, $lazy: true},
    }
  },
  setup() {
    return {
      v$: useVuelidate()
    }
  },
  watch:{
    partner: function(value) {
      if (this.suppliersID.includes(parseInt(value))) {
        this.currentPartner = this.suppliers.filter(item => item.id === parseInt(value))[0]
        this.partnerName = this.currentPartner.name
        this.partnerID = parseInt(value)
      } else {
        this.partnerName = value
        this.partnerID = null
      }
    }
  },
  mounted() {
    this.getItem(this.surveyID)
    this.partnerSelect()
    this.getConfiguration()
    // this.getSaveResult()
  },
  methods: {
    getConfiguration() {
      const key = `av_config_${this.userID}`
      if (localStorage.getItem(key) !== null) {
        const config = JSON.parse(localStorage.getItem(key))
        this.gapInput = config.gapInput
        this.statusSign = config.statusSign
      }
    },
    getSaveResult() {
      const key = `av_${this.$store.getters.id}_${this.$store.getters.accountid}`
      if (localStorage.getItem(key + '.data') !== null) {
        this.$confirm(
          {
            message: 'Wollen Sie die Prüfung vom letzten Mal fortsetzen?',
            button: {
              no: 'Nein',
              yes: 'Ja'
            },
            callback: confirm => {
              if (confirm) {
                this.partnerName = localStorage.getItem(key + '.partnerName')
                this.partnerAddress = localStorage.getItem(key + '.partnerAddress')
                this.filename = localStorage.getItem(key + '.filename')
                this.contractName = localStorage.getItem(key + '.contractName')
                this.auftragsgeber = localStorage.getItem(key + '.auftragsgeber')
                this.surveyResult = JSON.parse(localStorage.getItem(key + '.data'))
                this.partnerID = localStorage.getItem(key + '.partnerID')
                if (this.partnerID != null && this.partnerName != null) {
                  if (this.selectSuppliers.some(supplier => supplier.text === this.partnerName)) {
                    this.partner = this.selectSuppliers.filter(supplier => supplier.text === this.partnerName)[0].id
                    this.currentPartner = this.suppliers.filter(item => item.id === this.partnerID)[0]
                    $('.partner-select').val(this.partner).trigger('change')
                  } else {
                    this.partner = this.partnerName
                    const newOption = new Option(this.partnerName, this.partnerName, false, false);
                    $('.partner-select').append(newOption)
                    $('.partner-select').val(this.partnerName).trigger('change')
                  }
                } else {
                  this.partner = this.partnerID
                  this.currentPartner = this.suppliers.filter(item => item.id === this.partnerID)[0]
                  $('.partner-select').val(this.partnerID).trigger('change')
                }
                this.$vToastify.success('Erfolgreich geladen')
              } else {
                this.$vToastify.info('Neu Starten')
              }
            }
          }
        )
      }
    },
    saveConfiguration: function() {
      const key = `av_config_${this.userID}`
      localStorage.setItem(key, JSON.stringify({
        gapInput: this.gapInput,
        statusSign: this.statusSign,
      }))
    },
    surveyIDSelect: function() {
      this.getItem(this.surveyID)
    },
    uploadFile: async function() {
      const isValid = await this.v$.$validate()
      if (!isValid || this.contractFiles.length === 0) {
        this.$vToastify.error('Bitte fehlende Felder vervollständigen!')
        return
      }
      this.saveConfiguration()
      const formData = new FormData();
      for (let i = 0; i < this.contractFiles.length; i++) {
        formData.append('files', this.contractFiles[i].file);
      }
      formData.append('customerName', this.accountName);
      formData.append('partnerID', this.partnerID);
      formData.append('partnerName', this.partnerName);
      formData.append('partnerAddress', this.partnerAddress);
      formData.append('gapInput', this.gapInput);
      formData.append('auftragsgeber', this.auftragsgeber);
      formData.append('surveyID', this.surveyID);
      formData.append('appName', 'check');
      formData.append('modelName', 'surveyresult');
      formData.append('customerName', this.accountName);
      formData.append('contractName', this.contractName);
      formData.append('withoutSign', this.statusSign);
      formData.append('pdfPasswords', this.pdfPasswords);
      const headers = { 'Content-Type': 'multipart/form-data' };
      service.request({
        url: 'survey/v1/start_ai_check/',
        method: 'POST',
        data: formData,
        headers: headers
      }).then((res) => {
          sessionStorage.setItem(`av_${this.partnerName}`, JSON.stringify(res.data.files))
          setTimeout(() => {
            this.taskSetup = true
            this.$router.push({name: 'avv-list'})
          }, 2000) // 2000 milliseconds = 2 seconds
        }
      )

      // if (this.partnerID !== null && this.currentPartner != null && 'address' in this.currentPartner && this.currentPartner.address !== this.partnerAddress) {
      //   service.request({
      //     url: `todos/v1/get_supplier/${this.partnerID}/`,
      //     method: 'PUT',
      //     data: {
      //       address: this.partnerAddress
      //     }
      //   }).then((res) =>
      //     this.filename = res.file
      //   );
      // }
      this.v$.$reset()
    },
    openFileDialog() {
      this.$refs.fileInput.value = null; // Reset input so same file can be selected again
      this.$refs.fileInput.click();
    },
    removeFile(index) {
      this.contractFiles.splice(index, 1);
    },
    selectFile: function(e) {
      for (let i = 0; i< e.target.files.length; i++) {
        const file = e.target.files[i]
        if (file) {
          // Prevent duplicate files by name and size
          const exists = this.contractFiles.some(
            f => f.name === file.name && f.size === file.size
          );
          if (!exists) {
            this.contractFiles.push({
              id: this.fileId++,
              name: file.name,
              file: file,
              size: file.size,
            });
          }
        }
      }
    },
    getItem: function(id) {
      const that = this
      service.request({
        url: `survey/v1/survey/${id}/`,
        method: 'GET',
        responseType: 'json'
      }).then(function(response) {
        that.surveyJson = response.data.body
      }).catch(function(err) {
        console.log(err)
      })
    },
    partnerSelect() {
      const that = this
      service.request({
        url: `todos/v1/supplier/${that.accountid}/`,
        method: 'GET',
        responseType: 'json'
      }).then(function(response) {
        response.data.forEach(item => {
          that.suppliers.push(item)
          that.selectSuppliers.push({id: item.id, text: item.name})
          that.suppliersID.push(item.id)
        })
        $('.partner-select').select2({
          tags: true,
          width: '100%',
          data: that.selectSuppliers,
          placeholder: '----',
          allowClear: true
        })
        $('.partner-select').val('')
        $('.partner-select').trigger('change')
      }).catch(function(err) {
        console.log(err)
      })
    },
    exportSurveyToExcel() {
      surveyToExcel(this.surveyJson, this.accountName, 'AV-Prüfung', makeAVCoverSheet)
    },
  }
}
</script>

<style scoped>
.file-item {
  position: relative;
  background: #f3f3f3;
  border-radius: 4px;
  padding: 8px 32px 8px 12px;
  margin: 4px;
  min-width: 120px;
  display: flex;
  align-items: center;
}
.filename {
  font-size: 14px;
  color: #333;
}
.remove {
  position: absolute;
  top: 2px;
  right: 6px;
  color: #c00;
  font-weight: bold;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
  user-select: none;
}
.remove:hover {
  color: #f00;
}
</style>
